import React, { Component } from "react";
import { Spin, Radio, Space, message, DatePicker } from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import { logEvent } from "../../utils/analytics";

export default class RecentHealthEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      hospitalization_date: null,
      hospitalization_reason: "",
      have_you_hospitalization_in_past_three_months: "",
      list_of_surgeries: [
        {
          id: 1,
          date: null,
          reason: "",
        },
      ],
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (
                item.field ==
                "Have you been hospitalization in the past three months?"
              ) {
                this.setState({
                  have_you_hospitalization_in_past_three_months: item.value,
                });
              }
              if (
                item.field ==
                "Have you been hospitalization in the past three months?, then Date"
              ) {
                this.setState({
                  hospitalization_date: item.value ? dayjs(item.value) : null,
                });
              }
              if (
                item.field ==
                "Have you been hospitalization in the past three months?, then Reason"
              ) {
                this.setState({ hospitalization_reason: item.value });
              }
              if (item.field == "List of any surgeries") {
                let tempArr = item.value ? JSON.parse(item.value) : [];
                let newArr = [];
                for (let item of tempArr) {
                  let obj = {
                    id: item.id,
                    date: item.date ? dayjs(item.date) : null,
                    reason: item.reason,
                  };
                  newArr.push(obj);
                }
                this.setState({
                  list_of_surgeries: item.value
                    ? newArr
                    : [
                        {
                          id: 1,
                          date: null,
                          reason: "",
                        },
                      ],
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  save = () => {
    if (!this.state.have_you_hospitalization_in_past_three_months) {
      message.warning(
        "Please select value of 'Have you been hospitalization in the past three months?' field"
      );
      return;
    }
    if (this.state.list_of_surgeries.length == 0) {
      message.warning("Please add at least one surgery");
      return;
    }
    if (this.state.list_of_surgeries.length > 0) {
      for (let item of this.state.list_of_surgeries) {
        if (!item.date) {
          message.warning("Please add date of surgery");
          return;
        }
        if (!item.reason) {
          message.warning("Please add reason of surgery");
          return;
        }
      }
    }
    let questions = [
      {
        parent_field: "Have you been hospitalization in the past three months?",
        field: "Have you been hospitalization in the past three months?",
        value: this.state.have_you_hospitalization_in_past_three_months,
      },
      {
        parent_field:
          "Have you been hospitalization in the past three months?, then Date",
        field:
          "Have you been hospitalization in the past three months?, then Date",
        value: this.state.hospitalization_date
          ? dayjs(this.state.hospitalization_date).format("MM/DD/YYYY")
          : null,
      },
      {
        parent_field:
          "Have you been hospitalization in the past three months?, then Reason",
        field:
          "Have you been hospitalization in the past three months?, then Reason",
        value: this.state.hospitalization_reason,
      },
      {
        parent_field: "List of any surgeries",
        field: "List of any surgeries",
        value: JSON.stringify(this.state.list_of_surgeries),
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "8",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "recent_health_events" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(9);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  add_new_surgery = () => {
    let arr = this.state.list_of_surgeries;
    const randomInteger = this.getRandomInt(1, 2000);
    let obj = {
      id: randomInteger,
      date: null,
      reason: "",
    };
    arr.push(obj);
    this.setState({ list_of_surgeries: arr });
  };
  remove_surgery = (id) => {
    let arr = this.state.list_of_surgeries;
    let tempArr = [];
    for (let single of arr) {
      if (single.id != id) {
        tempArr.push(single);
      }
    }
    this.setState({ list_of_surgeries: tempArr });
  };
  update_surgery = (event, item, field) => {
    let arr = this.state.list_of_surgeries;
    let tempArr = [];
    for (let single of arr) {
      if (single.id == item.id) {
        if (field == "date") {
          single.date = event;
        }
        if (field == "reason") {
          single.reason = event.target.value;
        }
      }
      tempArr.push(single);
    }
    this.setState({ list_of_surgeries: tempArr });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment();
    };
    return (
      <div>
        <div className="header">
          <h3>RECENT HEALTH EVENTS</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2">
                Have you been hospitalization in the past three months?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_hospitalization_in_past_three_months:
                      event.target.value,
                    hospitalization_date: null,
                    hospitalization_reason: "",
                  })
                }
                value={this.state.have_you_hospitalization_in_past_three_months}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.state.have_you_hospitalization_in_past_three_months ==
              "Yes" && (
              <div>
                <div className="form-group">
                  <label className="mb-2 input-heading">
                    Date of Hospitalization
                    <span className="text-danger">*</span>
                  </label>
                  <br />
                  <DatePicker
                    onChange={(date, dateString) =>
                      this.setState({ hospitalization_date: date })
                    }
                    format={"MM/DD/YYYY"}
                    value={this.state.hospitalization_date}
                    style={{
                      width: "100%",
                      height: 55,
                      maxWidth: 500,
                    }}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-2">Reason for Hospitalization</label>
                  <br />
                  <textarea
                    className="form-control"
                    rows="4"
                    value={this.state.hospitalization_reason}
                    onChange={(event) =>
                      this.setState({
                        hospitalization_reason: event.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </div>
            )}
            <div className="form-group">
              <div className="d-flex justify-content-between col-lg-9">
                <label className="mb-2 input-heading">
                  List of any surgeries <span className="text-danger">*</span>
                </label>
                &nbsp;&nbsp;&nbsp;
                <button
                  className="add_row_button"
                  onClick={() => this.add_new_surgery()}
                >
                  {" "}
                  <box-icon name="plus-circle" color="#fff"></box-icon>{" "}
                  &nbsp;&nbsp;Add{" "}
                </button>
              </div>
              <br />
              <div className="col-lg-9">
                <table className="medical-history-table">
                  <tr>
                    <th>
                      Date <span className="text-danger">*</span>
                    </th>
                    <th>
                      Reason <span className="text-danger">*</span>
                    </th>
                    <th>Action</th>
                  </tr>
                  {this.state.list_of_surgeries.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <DatePicker
                            disabledDate={disabledDate}
                            value={item.date}
                            onChange={(date, dateString) =>
                              this.update_surgery(date, item, "date")
                            }
                            style={{
                              width: "100%",
                              height: 35,
                              maxWidth: 500,
                            }}
                            format={"MM/YYYY"}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={item.reason}
                            style={{ height: 35 }}
                            onChange={(e) =>
                              this.update_surgery(e, item, "reason")
                            }
                          />
                        </td>
                        <td>
                          <center>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => this.remove_surgery(item.id)}
                            >
                              <box-icon
                                size={"20px"}
                                name="trash"
                                color="red"
                              ></box-icon>
                            </span>
                          </center>
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(7)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
